var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgImagePlaceholder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 57,
    viewBox: "0 0 75 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9688 0H7.03125C3.14795 0 0 3.18992 0 7.125V49.875C0 53.8101 3.14795 57 7.03125 57H67.9688C71.8521 57 75 53.8101 75 49.875V7.125C75 3.18992 71.8521 0 67.9688 0ZM67.0898 49.875H7.91016C7.67706 49.875 7.4535 49.7812 7.28868 49.6141C7.12385 49.4471 7.03125 49.2206 7.03125 48.9844V8.01562C7.03125 7.77942 7.12385 7.55288 7.28868 7.38586C7.4535 7.21883 7.67706 7.125 7.91016 7.125H67.0898C67.3229 7.125 67.5465 7.21883 67.7113 7.38586C67.8762 7.55288 67.9688 7.77942 67.9688 8.01562V48.9844C67.9688 49.2206 67.8762 49.4471 67.7113 49.6141C67.5465 49.7812 67.3229 49.875 67.0898 49.875ZM18.75 13.0625C15.514 13.0625 12.8906 15.7209 12.8906 19C12.8906 22.2791 15.514 24.9375 18.75 24.9375C21.986 24.9375 24.6094 22.2791 24.6094 19C24.6094 15.7209 21.986 13.0625 18.75 13.0625ZM14.0625 42.75H60.9375V30.875L48.1179 17.8845C47.4315 17.1889 46.3185 17.1889 45.6319 17.8845L28.125 35.625L22.3367 29.7595C21.6502 29.0639 20.5373 29.0639 19.8507 29.7595L14.0625 35.625V42.75Z",
    fill: "#01035E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImagePlaceholder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/image-placeholder.4dbe26c2.svg";
export { ForwardRef as ReactComponent };